var _a;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { ASSIGNMENTS_ROUTES } from '../../constants/routes';
import { DataErrorModal, InvalidDatesModal } from './Modals';
var ModalsByError = (_a = {},
    _a["invalid_dates" /* dates */] = InvalidDatesModal,
    _a["error" /* other */] = DataErrorModal,
    _a);
var isAssignmentError = function (error) { var _a, _b; return Array.isArray((_b = (_a = error) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors); };
var AssignmentErrorBoundary = function (_a) {
    var children = _a.children, error = _a.error;
    var navigate = useNavigate();
    var hasError = isAssignmentError(error);
    var _b = useState(hasError), hasUnhandledError = _b[0], setUnhandledError = _b[1];
    useEffect(function () {
        setUnhandledError(hasError);
    }, [hasError]);
    if (hasError && hasUnhandledError) {
        var errorType = error.data.errors[0];
        var Modal = ModalsByError[errorType];
        return (_jsxs(_Fragment, { children: [children, _jsx(Modal, { open: hasUnhandledError, onClose: function () {
                        setUnhandledError(false);
                        navigate(ASSIGNMENTS_ROUTES.assignmentsList);
                    } }, void 0)] }, void 0));
    }
    return _jsx(_Fragment, { children: children }, void 0);
};
export { AssignmentErrorBoundary, isAssignmentError };
